<template>
  <hm-content>
    <div class="flex flex-end">
      <el-select
        size="small"
        v-model="conditionQuery.supplierCode"
        placeholder="请选择供货商"
        class="mr10"
        clearable
      >
        <el-option
          v-for="(v, i) in supply"
          :label="v.storeName"
          :value="v.storeCode"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        v-model="conditionQuery.storeCode"
        placeholder="请选择分销商"
        class="mr10"
        clearable
      >
        <el-option
          v-for="(v, i) in distributor"
          :label="v.storeName"
          :value="v.storeCode"
          :key="i"
        ></el-option>
      </el-select>
      <el-button type="primary" class="mr10" size="small" @click="queryPageList"
        >查询</el-button
      >
      <el-button
        type="primary"
        class="mr10"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div style="margin-top: 30px">
      <el-table :data="tableData" stripe size="small">
        <el-table-column
          align="center"
          prop=""
          label="序号"
          type="index"
          width="55"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="supplierName"
          label="供应商"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="shareStoreName"
          label="分销商"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="receiptSn"
          label="订单号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="payTime"
          label="付款时间"
        ></el-table-column>
        <el-table-column align="center" label="订单商品采购价">
          <template slot-scope="scope">
            <span>￥{{ scope.row.purchasePrice }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="订单代销金额">
          <template slot-scope="scope">
            <span>￥{{ scope.row.realPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="commissionPrice"
          label="分销商代销佣金"
        >
          <template slot-scope="scope">
            <span>￥{{ scope.row.commissionPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务费">
          <template slot-scope="scope">
            <span>￥{{ scope.row.feeAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="commissionState" label="佣金状态">
          <template slot-scope="scope">
            <span
              v-if="scope.row.commissionState == 'lock'"
              style="color: #2fc348"
              >锁定</span
            >
            <span v-else style="color: #ff0000">未锁定</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      isOutputing: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      distributor: [],
      supply: [],
      commissionStatus: [
        {
          label: "未锁定",
          value: "lock",
        },
        {
          label: "锁定",
          value: "noLock",
        },
      ],
      conditionQuery: {
        supplierCode: "",
        storeCode: "",
      },
      outputList:[],
    };
  },
  created() {
    this.queryPageList();
    this.query_share_store_list();
    this.query_auth_store_list();
  },
  methods: {
    async query_share_store_list() {
      //总供应商
      const { result } = await this.$store.dispatch("all_supplier_list");
      console.log(result);
      this.supply = result;
    },
    async query_auth_store_list() {
      //总分销商
      const { result } = await this.$store.dispatch("all_share_store_list");
      console.log(result);
      this.distributor = result;
    },
    async queryPageList(queryAll) {
      let params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: queryAll ? 1 : this.currentPage,
        queryStoreType: "hemiao",
      };
      const conditionSearch = JSON.parse(JSON.stringify(this.conditionQuery));
      Object.assign(params, conditionSearch);
      const { result } = await this.$store.dispatch(
        "storeSelectionOrderDetail",
        params
      );
      if(queryAll){
        this.outputList = result.records;
      }else{
        this.tableData = result.records;
      }
      this.total = result.total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryPageList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryPageList();
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryPageList("queryAll")
          .then((res) => {
            const list = this.outputList;
            list.forEach((v) => {
              if (v.commissionState === "lock") {
                v.commissionState = "锁定";
              } else {
                v.commissionState = "未锁定";
              }
            });
            console.log("list", list);

            const tHeader = [
              "供应商",
              "分销商",
              "订单号",
              "付款时间",
              "订单商品采购价",
              "订单代销金额",
              "分销商代销佣金",
              "服务费",
              "佣金状态",
            ];
            const filterVal = [
              "supplierName",
              "shareStoreName",
              "receiptSn",
              "payTime",
              "purchasePrice",
              "realPrice",
              "commissionPrice",
              "feeAmount",
              "commissionState",
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "（禾苗）代销结算" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>